import { ConvexError } from 'convex/values';

/**
 * Pull the human-readable message out of a Convex error. Our backend throws
 * `new ConvexError('<message>')`, so the string arrives as `error.data`.
 */
export function convexErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ConvexError && typeof error.data === 'string') {
    return error.data;
  }
  return fallback;
}
